
    var riot = require('riot')
     require('riot-kit/lib/form');require('riot-kit/lib/auth/forgot-password');
riot.tag2('signup', '<div if="{error}" class="alert alert-danger">{error}</div> <form width1="10" width2="2" class="form-horizontal"> <forminput name="first_name" label="First name" onupdate="{handleUpdate}" value="{user.first_name}" width1="3" width2="9" isrequired></forminput> <forminput name="surname" label="Surname" onupdate="{handleUpdate}" value="{user.surname}" width1="3" width2="9" isrequired></forminput> <forminput name="email" label="Email" onupdate="{handleUpdate}" value="{user.email}" width1="3" width2="9" isrequired></forminput> <forminput name="company" label="Company" onupdate="{handleUpdate}" value="{user.company}" width1="3" width2="9" isrequired></forminput> <formtextarea name="address" label="Address" onupdate="{handleUpdate}" value="{user.address}" width1="3" width2="9" isrequired></formtextarea> <forminput name="county" label="County" onupdate="{handleUpdate}" value="{user.county}" width1="3" width2="9" isrequired></forminput> <forminput name="postcode" label="Postcode" onupdate="{handleUpdate}" value="{user.postcode}" width1="3" width2="9" isrequired></forminput> <forminput name="country" label="Country" onupdate="{handleUpdate}" value="{user.country}" width1="3" width2="9" isrequired></forminput> <forminput name="phone1" label="Telephone" onupdate="{handleUpdate}" value="{user.phone1}" width1="3" width2="9" isrequired></forminput> <forminput name="phone2" label="Mobile" onupdate="{handleUpdate}" value="{user.phone2}" width1="3" width2="9"></forminput> <forminput name="password" label="Password" onupdate="{handleUpdate}" value="{user.password}" type="password" width1="3" width2="9" isrequired></forminput> <formsubmit if="{!opts.hidebutton}" onclick="{signup}" type="submit" width1="9" width2="3">Sign Up</formsubmit> </form>', '', '', function(opts) {
var loginApi, resource;

resource = require('riot-kit/utils/apiResource.coffee');

loginApi = new resource(opts.src || '/duocms/api/register', true);

this.on('mount', function() {
  console.log("opts", opts);
  return this.root.trigger = this.trigger;
});

this.on('reset', (function(_this) {
  return function() {
    return _this.reset();
  };
})(this));

this.on('signup', (function(_this) {
  return function() {
    return _this.signup();
  };
})(this));

this.readCookie = (function(_this) {
  return function(name) {
    var c, ca, i, nameEQ;
    nameEQ = name + '=';
    ca = document.cookie.split(';');
    i = 0;
    while (i < ca.length) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
      i++;
    }
    return null;
  };
})(this);

this.user = {
  email: '',
  password: '',
  name: '',
  company: ''
};

this.reset = (function(_this) {
  return function() {
    _this.user.email = '';
    _this.user.password = '';
    _this.user.name = '';
    _this.user.company = '';
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(input) {
    return _this.user[input.name] = input.value;
  };
})(this);

this.signup = (function(_this) {
  return function() {
    _this.error = null;
    return loginApi.save(_this.user, function(user, error) {
      if (error != null) {
        _this.error = error.message;
        return _this.update();
      } else {
        if ((opts.onsignup != null) && typeof opts.onsignup === "function") {
          _this.opts.onsignup(user);
        }
        return window.location.href = '/system/registration_pending/';
      }
    });
  };
})(this);
});
riot.tag2('signup-modal', '<yield></yield> <modal name="signupmodal" onclose="{close}" title="Sign Up" savetext="Sign Up" onsave="{handlesignup}" esckey="{true}"> <signup onsignup="{parent.signedin}" hidebutton="{true}" hidesignup="{true}"></signup> </modal>', 'signup-modal { cursor: pointer; }', 'onclick="{show}"', function(opts) {
this.on('mount', function() {
  this.root.trigger = this.trigger;
  this.signupmodal = this.tags.signupmodal;
  this.signup = this.signupmodal.tags.signup;
  return this.update();
});

this.on('show', (function(_this) {
  return function() {
    return _this.show();
  };
})(this));

this.show = (function(_this) {
  return function() {
    document.addEventListener('keydown', _this.keydown);
    return _this.signupmodal.show();
  };
})(this);

this.keydown = (function(_this) {
  return function(e) {};
})(this);

this.close = (function(_this) {
  return function() {
    document.removeEventListener('keydown', _this.keydown);
    return _this.signup.trigger('reset');
  };
})(this);

this.signedin = (function(_this) {
  return function(user) {
    _this.signupmodal.close();
    if ((opts.onsignup != null) && typeof opts.onsignup === "function") {
      return opts.onsignup(user);
    }
  };
})(this);

this.handlesignup = (function(_this) {
  return function() {
    return _this.signup.trigger('signup');
  };
})(this);
});
    
  